import { request } from './request'
import { useServerFetch } from '../composables/useServerFetch'
import { useEnvApi } from '../composables/useEnvApi'

const FOOTER_HOT_COUNTRIES_API_PATH = `${WIKIBITWEBV1}/country/hot-v1`

export type FooterHotCountryItem = {
  abbr?: string
  code?: string
  countryCode?: string
  name?: string
  url?: string
  flag?: string
  twoCharCode?: string
  'flag-c'?: string
}

export type FooterHotCountriesResponse = {
  data?: FooterHotCountryItem[]
}

export const getFooterHotCountries = (): Promise<FooterHotCountriesResponse | FooterHotCountryItem[] | null> => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.testwikidatacenter : api.homeClient,
    url: FOOTER_HOT_COUNTRIES_API_PATH,
    method: 'GET' as const,
  }

  return import.meta.server ? useServerFetch<FooterHotCountriesResponse>(requestConfig) : request(requestConfig)
}
